// Api
import API from '@/api'
// Services
import { http } from '@/boot/axios'

/**
 * Exportacion asincrona del Reporte de Licencias (TKT-2285, "Inteligencia Operativa").
 *
 * Pega contra binnacle-graphql-api, bajo `reports/`, NO bajo `licenses/` como el resto del modulo
 * (services/licenses.js): este endpoint es un job de exportacion, no una lectura paginada. Mismo
 * contrato que ReportsService.requestGeneralReportByNotification (services/reports.js) para el
 * Reporte General -- `delivery=notification` dispara el job y responde de inmediato; el archivo
 * llega despues por el panel de notificaciones, deep-link a /pdf-descarga/:token.
 *
 * Nombres de parametros asumidos del lado del backend (branch companion
 * feat/TKT-2285-reporte-licencias en binnacle-graphql-api, en construccion en paralelo): a
 * reconciliar en revision si el backend real difiere.
 */
const URL = `${API.GRAPHQL_URL}reports/licensesExcelEmail`

// PDF, fase 3 (TKT-2285). Mismo contrato "fire-and-forget + notificacion" que el XLSX de arriba,
// solo cambia el endpoint -- contrato asumido del companion backend
// feat/TKT-2285-fase3-kpi-global-pdf (en construccion en paralelo, no verificado contra una
// instancia real): a reconciliar en revision si el backend real difiere.
const PDF_URL = `${API.GRAPHQL_URL}reports/licensesPdfEmail`

export default {
  requestByNotification ({ organizationId, franchiseId, status }) {
    return http.get(URL, {
      params: {
        delivery: 'notification',
        organization_id: organizationId,
        franchise_id: franchiseId,
        status
      }
    })
  },
  requestPdfByNotification ({ organizationId, franchiseId, status }) {
    return http.get(PDF_URL, {
      params: {
        delivery: 'notification',
        organization_id: organizationId,
        franchise_id: franchiseId,
        status
      }
    })
  }
}
